var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLikeHeartOutlined16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.312 2.64a4.033 4.033 0 00-3.003-1.306 3.773 3.773 0 00-2.356.813c-.364.284-.685.62-.953.995a4.82 4.82 0 00-.953-.995 3.772 3.772 0 00-2.356-.813 4.033 4.033 0 00-3.003 1.305A4.688 4.688 0 00.501 5.841a5.582 5.582 0 001.488 3.654 31.717 31.717 0 003.723 3.496c.516.44 1.101.938 1.708 1.468a.88.88 0 001.16 0c.607-.534 1.192-1.03 1.709-1.468a31.702 31.702 0 003.723-3.495A5.582 5.582 0 0015.5 5.841a4.688 4.688 0 00-1.19-3.202h.003z",
    stroke: "#000",
    strokeLinejoin: "round"
  })));
}

export default SvgLikeHeartOutlined16X16;